import { render, staticRenderFns } from "./wechat_assistant_list.vue?vue&type=template&id=6c089b58&scoped=true&"
import script from "./wechat_assistant_list.vue?vue&type=script&lang=js&"
export * from "./wechat_assistant_list.vue?vue&type=script&lang=js&"
import style0 from "./wechat_assistant_list.vue?vue&type=style&index=0&id=6c089b58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c089b58",
  null
  
)

export default component.exports